module.exports = __webpack_public_path__ + "media/images/en_badge_web_generic-b7aa392153c1e8912d9a556303ebd963.png";